// libs
import styled, { css } from "styled-components";
// theme
import { colors, typography } from "src/theme";

export const MainRow = styled.div<{ margin?: string; wrap?: string }>`
  display: flex;
  ${({ margin }) => margin && `margin: ${margin}`};
  ${({ wrap }) => wrap && `flex-wrap: ${wrap}`};
`;

export const Row = styled.div<{ margin?: string; wrap?: string }>`
  display: flex;
  align-items: center;
  ${({ margin }) => margin && `margin: ${margin}`};
  ${({ wrap }) => wrap && `flex-wrap: ${wrap}`};
`;

export const Column = styled.div<{ margin?: string }>`
  ${({ margin }) => margin && `margin: ${margin}`};
`;

export const Wrapper = styled.div`
  border-radius: 12px;
  cursor: pointer;
  transition: 0.3s all ease;
  padding: 8px;
  margin: -8px;

  :hover {
    background-color: ${colors.greyVeryLight};
  }
`;

export const NextImageWrapper = styled.div<{ bg: string; isCustomBg?: boolean }>`
  height: 64px;
  width: 64px;
  flex-shrink: 0;
  position: relative;
  border-radius: 8px;
  background-image: ${({ bg }) => `url(${bg})`};
  background-repeat: no-repeat;
  background-size: ${({ isCustomBg }) => (isCustomBg ? "contain" : "cover")};
  background-position: center;
`;

export const ClinicTitle = styled.p`
  font-family: ${typography.fontFamily};
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: 32px;
  letter-spacing: 0;
  text-align: left;
  color: ${colors.greyDark};
`;

export const ClinicAddress = styled.p`
  font-family: ${typography.fontFamily};
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0;
  text-align: left;
  color: ${colors.grey};
  margin-right: 10px;
`;

export const RatingCountText = styled.p`
  font-family: ${typography.fontFamily};
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 20px;
  display: flex;
  align-items: center;
  color: ${colors.main};
  margin-left: 10px;
`;

export const RateText = styled.p<{ margin?: string }>`
  font-family: ${typography.fontFamily};
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0;
  text-align: left;
  color: ${colors.grey};
  white-space: nowrap;
  ${({ margin }) => margin && `margin: ${margin}`};
`;

export const SpeciesList = styled.ul`
  display: flex;
  align-items: center;
  white-space: nowrap;
  flex-wrap: wrap;
  list-style: none;
`;

const offsetFromFirst = css`
  ::after {
    content: none;
  }
`;
const offsetFromSecond = css`
  ::after {
    content: "·";
    position: absolute;
    right: 6px;
    color: ${colors.grey};
  }
`;

export const SpeciesButton = styled.li<{ offsetFirst?: boolean }>`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px 16px 10px 0;
  border-radius: 4px;
  list-style: none;

  font-family: ${typography.fontFamily};
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  color: ${colors.greyDark};

  ${({ offsetFirst }) => (offsetFirst ? offsetFromSecond : offsetFromFirst)};
`;

export const RecommendedButton = styled.li`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
    margin: 7px;
    padding: 4px;
  border-radius: 4px;
  list-style: none;

  font-family: ${typography.fontFamily};
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  color: ${colors.greyDark};
  background-color: ${colors.mainLight};
`;

export const SpeciesItem = styled.li`
  position: relative;
  font-family: ${typography.fontFamily};
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0;
  text-align: left;
  color: ${colors.grey};
  padding: 0;
  padding-right: 16px;

  ::after {
    content: "·";
    position: absolute;
    right: 6px;
  }
  :last-child::after {
    content: none;
  }
`;
